import get from 'lodash/get';

// TODO do not take into account empty fields
export const averageField = (array, field, ignoreZeroField) => {
  let numberValidFields = 0;

  const sumOfValidFields = array.reduce((accumulator, item) => {
    const currentValue = get(item, field);

    if (!Number.isFinite(currentValue)) {
      return accumulator;
    }
    if (ignoreZeroField && currentValue === 0) {
      return accumulator;
    }

    numberValidFields += 1;
    return accumulator + currentValue;
  }, 0);

  if (numberValidFields === 0) {
    return undefined;
  }

  return sumOfValidFields / numberValidFields;
};

export function bySortValue({ sort: sortA } = {}, { sort: sortB } = {}) {
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(sortA) && !isNaN(sortB)) {
    return sortA - sortB;
  }

  return 0;
}

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export function flatten(items, subKey, parentId = '') {
  const flat = [];
  let nextParentId;

  Object.values(items).forEach((item) => {
    const { id, [subKey]: subDictionary } = item;
    const subItems = Object.values(subDictionary || {});
    nextParentId = `${parentId}${id}`;
    flat.push({ ...item, ids: nextParentId });

    if (subItems.length) {
      flat.push(...flatten(subItems, subKey, `${nextParentId}.`));
    }
  });

  return flat;
}
